'use strict';

class Operators {
	constructor(options) {
		console.log('Operators::constructor(%o)', options);

		this.defaults = {
			search_input: document.getElementById('search-input'),
			search_result: document.getElementById('search-suggestions'),
			hint_list: document.getElementById('search-suggestions').getElementsByTagName('ul')[0],
			suggestion_link: s.url('/send/recharge'),
			operator_names: {},
			selectedIndex: 0
		}

		this.options = Object.assign(this.defaults, options);
		this.pageEvents();
	}

	pageEvents() {
		this.options.search_input.addEventListener('keydown', e => this.showSuggestions(e));
		document.addEventListener('click', (e) => {
			if (e.target !== this.options.search_result && e.target !== this.options.search_input) {
				this.options.search_result.classList.add('d-none');
			}
		});
		this.options.search_input.addEventListener('focus', () => {
			this.options.search_result.classList.remove('d-none');
		});
	}

	showSuggestions(e) {
		if (e.key === 'Escape') {
			this.options.search_result.classList.add('d-none');
			this.options.search_input.value = '';
			this.options.hint_list.innerHTML = '';
		} else {
			if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown' && e.key !== 'Enter') {
				const searched_string = this.options.search_input.value.toLowerCase();
				const hints = this.options.operator_names.filter(operator_name => operator_name.toLowerCase().includes(searched_string));

				this.options.hint_list.innerHTML = '';

				if (searched_string.length > 0) {
					this.options.selectedIndex = 0;
					let li;

					if (hints.length > 0) {
						hints.forEach((operator_name, i) => {
							li = document.createElement('li');
							li.dataset.arrowSelect = i == 0;
							const link = document.createElement('a');
							link.href = this.options.suggestion_link + '/' + encodeURI(operator_name);
							link.innerText = operator_name;
							li.appendChild(link);
							this.options.hint_list.appendChild(li);
						});
					} else {
						li = document.createElement('li');
						li.classList.add('not-found');
						li.innerText = s.it('LOCAL_OPERATOR_NOT_AVAILABLE');
						this.options.hint_list.appendChild(li);
					}

					this.options.search_result.classList.remove('d-none');
				}
			} else {
				if (e.key === 'Enter') {
					this.options.hint_list.children[this.options.selectedIndex].querySelector('a').click();
				} else {
					e.preventDefault();

					if (!this.options.search_result.classList.contains('d-none')) {
						this.options.search_result.querySelectorAll('li').forEach(suggestion => {
							suggestion.dataset.arrowSelect = false;
						});

						switch (e.key) {
							case 'ArrowUp':
								this.options.selectedIndex > 0 ? this.options.selectedIndex-- : 0;
								break;
							case 'ArrowDown':
								this.options.selectedIndex < this.options.hint_list.children.length - 1 ? this.options.selectedIndex++ : this.options.hint_list.children.length - 1;
								break;
						}

						this.options.hint_list.children[this.options.selectedIndex].dataset.arrowSelect = true;
					}
				}
			}
		}
	}
}
